// material-ui
import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";

// project import
import MainCard from "components/MainCard";
import { FormattedMessage } from "react-intl";

import { ResumeSubscription } from "types/resumes-managment/resume-subscription";

// ==============================|| EXPANDING TABLE - RESUME SUBSCRIPTION DETAILS ||============================== //

interface ExpandingResumeSubscriptionDetailsProps {
  data: ResumeSubscription;
}

const ExpandingResumeSubscriptionDetails = ({
  data,
}: ExpandingResumeSubscriptionDetailsProps) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard
            title={<FormattedMessage id="Resume Subscription Details" />}
          >
            <List sx={{ py: 0 }}>
              {/* IDs */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Resume Package Id" />
                      </Typography>
                      <Typography>{data.resume_package_id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Order Id" />
                      </Typography>
                      <Typography>{data.resume_order_id}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Company & Status */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Company Name" />
                      </Typography>
                      <Typography>{data.company_name}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Status" />
                      </Typography>
                      <Typography>
                        {data.status ? (
                          <FormattedMessage id="active" />
                        ) : (
                          <FormattedMessage id="inactive" />
                        )}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Counts */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Total Resumes" />
                      </Typography>
                      <Typography>{data.amount_resumes}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Used Resumes" />
                      </Typography>
                      <Typography>{data.used_resumes}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Dates */}
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="From" />
                      </Typography>
                      <Typography>{data.start_date}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="To" />
                      </Typography>
                      <Typography>{data.end_date}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>

              {/* Created / Updated */}
              <ListItem>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Created At" />
                      </Typography>
                      <Typography>{data.created_at}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        <FormattedMessage id="Updated At" />
                      </Typography>
                      <Typography>{data.updated_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingResumeSubscriptionDetails;
